import React from "react";

const Penertiban = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Penertiban Dalops"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=147&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDk5NzMzNzYyLCJJZGVudGl0eSI6MTQ3LCJUb2tlblR5cGUiOjB9.rqPr-8gSO7-XBMdb_Qw6D3YuoqRRwT9gHaAm5n3OgRo&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Penertiban;
